import React, { FC } from "react";
import { ShareMatterModal } from "@design-system";
import { useShareMatterViewModel } from "../hooks/share-matter";
import { UsersSelectContainer } from "./users/users-select-container";

export type ShareMatterContainerProps = {
  matterId: number;
  matterTitle: string;
  externalMatterId?: number;
  clientName?: string;
  clientId?: number;
  onClose: () => void;
  opts: {
    isParentMatter: boolean;
  };
};

export const ShareMatterContainer: FC<ShareMatterContainerProps> = ({
  matterId,
  matterTitle,
  externalMatterId,
  clientName,
  clientId,
  onClose,
  opts: { isParentMatter },
}) => {
  const vm = useShareMatterViewModel(matterId);
  return (
    <ShareMatterModal
      loading={vm.loading()}
      status={vm.status()}
      matterTitle={matterTitle}
      clientName={clientName}
      collaboratorUsers={vm.collaboratorUsers()}
      onClose={onClose}
      onShare={(data) => vm.share(data, isParentMatter)}
      alertMessage={vm.alertMessage()}
      show={true}
      renderUsersSelect={(disabled) => (
        <UsersSelectContainer
          mode="tags"
          style={{ width: "100%" }}
          placeholder="Select colleagues to share with..."
          disabled={disabled}
          requiredUsers={vm.collaboratorUsers()}
          externalMatterId={externalMatterId}
          clientId={clientId}
        />
      )}
      onRemoveCollaborator={(userId) => vm.removeCollaborator(userId, isParentMatter)}
    />
  );
};
